<template>
<div class="list-view">
  <div class="backingpanel">
    <div class="column is-inline-block dash-panel">
      <div class="dash-panel-title">UPCOMING PRODUCTION ORDERS
      </div>
      <div class="dash-holder-480" id="stats"></div>
    </div>
    <div class="column is-inline-block dash-panel">
      <div class="dash-panel-title">PRODUCTIVITY BY PROJECT
      </div>
      <div class="dash-holder-480" id="productivity"></div>
    </div>
    <div class="column is-inline-block dash-panel">
      <div class="dash-panel-title">PRODUCTIVITY BY WORK STEP
      </div>
      <div class="dash-holder-480" id="prodws"></div>
    </div>
    <div class="column is-inline-block dash-panel">
      <div class="dash-panel-title">SHOP HOURS
      <select v-model="shopResourceTimeFrame">
                <option v-for="option in shopTimeOptions" :key="option.value" :value="option.value">{{option.text}}</option>
              </select>
      </div>
      <div class="dash-holder-480" id="resource"></div>
    </div>
  </div>
</div>
</template>

<script>
import {
  defineComponent, reactive, toRefs, ref, onMounted, computed, watch, watchEffect,
} from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import PowerBIToken from '@/models/PowerBI';
import * as pbi from 'powerbi-client';
import Vendors from '@/models/Vendors';
import _ from 'lodash';
import moment from 'moment';

import Version from '@/appVersion.json';

export default defineComponent({
  name: 'Home',
  setup() {
    const router = useRouter();

    function filterDash() {
      this.reports.forEach((report) => {
        report.updateFilters();
      });
    }

    function setupReport(report, drill) {
      // Clear any other loaded handler events
      report.off('loaded');

      // Triggers when a report schema is successfully loaded
      report.on('loaded', () => {
        // report.updateFilters(pbi.models.FiltersOperations.Add, [myFilter]);
      });

      // Clear any other rendered handler events
      report.off('rendered');

      // Triggers when a report is successfully embedded in UI
      report.on('rendered', () => {
        console.log('Report render successful');
      });

      // Clear any other error handler events
      report.off('error');

      // Handle embed errors
      report.on('error', (event) => {
        const errorMsg = event.detail;
        console.error(errorMsg);
      });

      report.off('dataHyperlinkClicked');

      report.on('dataHyperlinkClicked', (event) => {
        const url = _.get(event, 'detail.url').replaceAll('&amp;', '&');

        const split = url.split('?');
        if (split.length === 2) {
          const urlParams = new URLSearchParams(`?${split[1]}`);

          // TODO parse out the route as well as params!
          let routePath = '/scm/production-status/order-view';
          if (url.search('/#/managers/')) {
            const split2 = split[0].split('#');
            routePath = split2[1];
            console.log(routePath);
          }
          const params = {};

          params.fromDashBoard = true;

          if (urlParams.get('hasCompleteWorksteps')) {
            params.hasCompleteWorksteps = urlParams.get('hasCompleteWorksteps');
          }
          if (urlParams.get('hasActualHrs')) {
            params.hasActualHrs = urlParams.get('hasActualHrs');
          }
          if (urlParams.get('hasPlannedHrs')) {
            params.hasPlannedHrs = urlParams.get('hasPlannedHrs');
          }
          if (urlParams.get('hasProductivity')) {
            params.hasProductivity = urlParams.get('hasProductivity');
          }
          if (urlParams.get('productionStatus')) {
            params.productionStatus = urlParams.get('productionStatus');
          }
          if (urlParams.get('productivityRange')) {
            params.productivityRange = urlParams.get('productivityRange');
          }
          if (urlParams.get('project')) {
            params.project = urlParams.get('project');
          }
          if (urlParams.get('orderStage')) {
            params.orderStage = urlParams.get('orderStage');
          }
          if (urlParams.get('shopMonth')) {
            params.shopMonth = urlParams.get('shopMonth');
          }
          if (urlParams.get('shopWeek')) {
            params.shopWeek = urlParams.get('shopWeek');
          }

          if (urlParams.get('productivityStatus')) {
            params.productivityStatus = urlParams.get('productivityStatus');
          }
          if (urlParams.get('wsOrderId')) {
            params.wsOrderId = urlParams.get('wsOrderId');
          }

          drill(routePath, params);
        }
      });

      report.off('buttonClicked');

      report.on('buttonClicked', (event) => {
        const url = _.get(event, 'detail.title');

        const split = url.split('?');
        if (split.length === 2) {
          const urlParams = new URLSearchParams(`?${split[1]}`);

          // TODO parse out the route as well as params!
          const routePath = '/scm/production-status/order-view';
          const params = {};

          params.fromDashBoard = true;

          if (urlParams.get('hasCompleteWorksteps')) {
            params.hasCompleteWorksteps = urlParams.get('hasCompleteWorksteps');
          }
          if (urlParams.get('hasActualHrs')) {
            params.hasActualHrs = urlParams.get('hasActualHrs');
          }
          if (urlParams.get('hasPlannedHrs')) {
            params.hasPlannedHrs = urlParams.get('hasPlannedHrs');
          }
          if (urlParams.get('hasProductivity')) {
            params.hasProductivity = urlParams.get('hasProductivity');
          }
          if (urlParams.get('productionStatus')) {
            params.productionStatus = urlParams.get('productionStatus');
          }
          if (urlParams.get('productivityRange')) {
            params.productivityRange = urlParams.get('productivityRange');
          }
          if (urlParams.get('project')) {
            params.project = urlParams.get('project');
          }
          if (urlParams.get('orderStage')) {
            params.orderStage = urlParams.get('orderStage');
          }
          if (urlParams.get('shopMonth')) {
            params.shopMonth = urlParams.get('shopMonth');
          }
          if (urlParams.get('shopWeek')) {
            params.shopWeek = urlParams.get('shopWeek');
          }

          drill(routePath, params);
        }
      });

      report.off('dataSelected');

      report.on('dataSelected', (event) => {
        console.log(`data selected: ${event.detail}`);
      });
    }

    let showDash = true; // Dont commit this change, update this to true for UI instance and local
    if (_.get(Version, 'env', '') == 'dev') {
      showDash = true;
    }

    function drill(path, query) {
      router.push({ path, query });
    }
    const getDynamicClasses = computed(() => {
      const routeMeta = router.currentRoute.value.meta;
      let classes = '';
      if (routeMeta.activeViewColor) {
        classes = `${routeMeta.activeViewColor} `;
      }
      if (routeMeta.cardEditIcon) {
        classes += `icon-${routeMeta.cardEditIcon}`;
      }
      return classes;
    });
    const store = useStore();
    const data = reactive({
      isActive: false,
      allCategories: [],
    });
    const clickActivity = () => {
      data.isActive = true;
    };

    const showSecond = ref(false);
    const showThird = ref(false);
    const biRef = ref('<div></div>');
    const showMobile = false;

    const reports = [];

    const projectIds = computed(() => store.getters.selectedIdsForKey('filteredProjects'));

    const projectFilter = {
      $schema: 'http://powerbi.com/product/schema#basic',
      target: {
        table: 'projects',
        column: '_id',
      },
      operator: 'In',
      values: projectIds.value,
      filterType: pbi.models.FilterType.Basic,
      displaySettings: {
        isHiddenInViewMode: true,
      },
    };

    const projectFilterP = {
      $schema: 'http://powerbi.com/product/schema#basic',
      target: {
        table: 'productionOrders',
        column: 'project._id',
      },
      operator: 'In',
      values: projectIds.value,
      filterType: pbi.models.FilterType.Basic,
      displaySettings: {
        isHiddenInViewMode: true,
      },
    };

    const shopTimeOptions = [
      {
        value: 'b', text: 'Monthly',
      },
      {
        value: 'a', text: 'Weekly',
      },
    ];

    const shopResourceTimeFrame = ref('a');

    watchEffect(() => {
      const { text } = shopTimeOptions.find((element) => element.value === shopResourceTimeFrame.value);
      if (reports[2]) {
        if (text === 'Weekly') {
          reports[2].setPage('ReportSection4abb0c031108e398b5a7');
        } else {
          reports[2].setPage('ReportSection1dffa25ea60eea49566a');
        }
      }
    });

    watch(() => store.state.queryParams.projects, () => {
      projectFilter.values = projectIds.value;
      projectFilterP.values = projectIds.value;
      // for some reason reports.each did not work here...
      reports[0].updateFilters(pbi.models.FiltersOperations.Replace, [projectFilter, projectFilterP]);
      reports[1].updateFilters(pbi.models.FiltersOperations.Replace, [projectFilter, projectFilterP]);
      reports[2].updateFilters(pbi.models.FiltersOperations.Replace, [projectFilter, projectFilterP]);
      reports[3].updateFilters(pbi.models.FiltersOperations.Replace, [projectFilterP]);
    });

    onMounted(async () => {
      data.allCategories = (await Vendors.getCategories({ limit: 500 })).data;
      await PowerBIToken.getEmbedToken().then((response) => {
        const embedData = response;

        // set up the request object
        const metrics = {
          type: 'report',
          tokenType: pbi.models.TokenType.Embed,
          accessToken: embedData.accessToken,

          // Use other embed report config based on the requirement.
          // We have used the first one for demo purpose
          embedUrl: embedData.embedUrl[0].embedUrl,
          // ALWAYS specify page name to future-proof
          pageName: '',
          reportSection: '',

          // Enable this setting to remove gray shoulders from embedded report
          // settings: {
          //     background: models.BackgroundType.Transparent
          // }
          settings: {
            layoutType: (showMobile ? pbi.models.LayoutType.MobilePortrait
              : pbi.models.LayoutType.Master),
            panes: {
              pageNavigation: {
                visible: false,
              },
              filters:
              {
                visible: false,
              },
            },
            hyperlinkClickBehavior: pbi.models.HyperlinkClickBehavior.RaiseEvent,
          },
          filters: [],
        };

        // Use the token expiry to regenerate Embed token for seamless end user experience
        // Refer https://aka.ms/RefreshEmbedToken
        // const tokenExpiry = embedData.expiry;

        // Embed Power BI report when Access token and Embed URL are available

        const powerbi = new pbi.service.Service(pbi.factories.hpmFactory,
          pbi.factories.wpmpFactory, pbi.factories.routerFactory);
        // console.log(`categories: ${JSON.stringify(data.allCategories)}`);

        metrics.pageName = 'ReportSection904e47e1938f163b0e3e';
        metrics.filters = [projectFilter, projectFilterP];
        let reportholder = document.getElementById('productivity');
        let report = powerbi.embed(reportholder, metrics);
        setupReport(report, drill);
        reports.push(report);

        metrics.pageName = 'ReportSection2b35382c561970780b88';
        metrics.filters = [projectFilter, projectFilterP];
        reportholder = document.getElementById('prodws');
        report = powerbi.embed(reportholder, metrics);
        setupReport(report, drill);
        reports.push(report);

        metrics.pageName = 'ReportSection4abb0c031108e398b5a7';
        metrics.filters = [projectFilter, projectFilterP];
        reportholder = document.getElementById('resource');
        report = powerbi.embed(reportholder, metrics);
        setupReport(report, drill);
        reports.push(report);

        metrics.pageName = 'ReportSection7665cc20c22ea07b5c90';
        metrics.filters = [projectFilterP];
        reportholder = document.getElementById('stats');
        report = powerbi.embed(reportholder, metrics);
        setupReport(report, drill);
        reports.push(report);
      });
    });

    return {
      ...toRefs(data),
      clickActivity,
      showSecond,
      showThird,
      biRef,
      showMobile,
      reports,
      getDynamicClasses,
      showDash,
      projectIds,
      shopResourceTimeFrame,
      shopTimeOptions,
    };
  },
});
</script>
<style scoped>

</style>
